export type TPAMS_REPORTS_LOAD_SUMMARY = 'TPAMS_REPORTS_LOAD_SUMMARY';
export const TPAMS_REPORTS_LOAD_SUMMARY: TPAMS_REPORTS_LOAD_SUMMARY = 'TPAMS_REPORTS_LOAD_SUMMARY';

export type TPAMS_REPORTS_LOAD_REPORTS = 'TPAMS_REPORTS_LOAD_REPORTS';
export const TPAMS_REPORTS_LOAD_REPORTS: TPAMS_REPORTS_LOAD_REPORTS = 'TPAMS_REPORTS_LOAD_REPORTS';

export type TPAMS_REPORTS_LOAD_MONTHLY_REPORTS = 'TPAMS_REPORTS_LOAD_MONTHLY_REPORTS';
export const TPAMS_REPORTS_LOAD_MONTHLY_REPORTS: TPAMS_REPORTS_LOAD_MONTHLY_REPORTS
    = 'TPAMS_REPORTS_LOAD_MONTHLY_REPORTS';
